<template>
  <div class="addProject">
    <h3 class="title">{{title}}</h3>
    <el-form label-width="100px" :model="formData" ref="formData">
      <div class="card">
        <el-form-item label="名称" prop="menuName">
          <el-input v-model="formData.menuName" placeholder="请输入名称" @input="testSX" style="width:90%;"></el-input>
        </el-form-item>
        <div>
          <div class="flex" v-for="(domain, idx) in formData.productList " :key="idx">
            <el-form-item label="规格" class="list">
              <el-input v-model="domain.menuSpec" placeholder="请输入规格" @input="testSX"></el-input>
            </el-form-item>
            <el-form-item label="价格" class="list">
              <el-input v-model="domain.price" placeholder="请输入价格" @input="testSX"></el-input>
            </el-form-item>
            <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(domain,idx)" v-show="idx > 0">
              <i class="el-icon-delete"></i>
            </el-button>
          </div>
          <el-form-item style="text-align: right;margin-right:5%;">
            <el-button @click="editDomain" type="primary" size="mini">新增产品</el-button>
          </el-form-item>
        </div>
        <!-- <div v-if="code==1">
          <el-form-item label="规格" class="list">
            <el-input v-model="formData.menuSpec" placeholder="请输入规格" @input="testSX" style="width:90%;"></el-input>
          </el-form-item>
          <el-form-item label="价格" class="list">
            <el-input v-model="formData.price" placeholder="请输入价格" @input="testSX" style="width:90%;"></el-input>
          </el-form-item>
        </div> -->

        <el-form-item label="登记表">
          <el-radio-group v-model="formData.registrationType" :disabled="disabled">
            <el-radio label="1">外科</el-radio>
            <el-radio label="2">注射微整科</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="产品/注假名称" prop="menuType">
          <el-select v-model="formData.type" clearable="" placeholder="请选择类型" @input="testSX" style="width:90%;" :disabled="disabled">
            <el-option v-for="(item,index) in types" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="footer">
        <el-form-item>
          <el-button type="danger" @click="resetForm('formData')">取 消</el-button>
          <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ['code', 'formData'],
  data() {
    return {
      title: '',
      disabled: false,
      types: [
        {
          label: '产品',
          value: '1',
        },
        {
          label: '注假名称',
          value: '2',
        },
      ],
    }
  },
  created() {
    if (this.code == 0) {
      this.title = '新增产品'
      this.disabled = false
      console.log(this.formData.productList);
    } else if (this.code == 1) {
      this.title = '编辑产品'
      this.disabled = true
    }
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },///bs/register/createRegisterMenu
    doAddgoods(formData) {
      console.log(this.code);
      let createBy = Lockr.get("skinEmpId");
      this.formData.createBy = createBy
      //   新增数据
      if (this.code == 0) {
        this.$refs[formData].validate((valid) => {
          api.requestQuiet("/register/createRegisterMenuProduct", this.formData, (res) => {
            if (res.result == true) {
              _g.toast("success", '新增成功!');
              this.$emit('add-comment')
              this.$emit('closeDialog')
            } else {
              _g.toast("error", '新增失败!');
            }
          }, (err) => {
            this.loading = false
          })
        })
      } else if (this.code == 1) {//修改数据
        this.$refs[formData].validate((valid) => {
          api.requestQuiet("/register/updateRegisterMenuProduct", this.formData, (res) => {
            if (res.result == true) {
              _g.toast("success", '修改成功!');
              this.$emit('add-comment')
              this.$emit('closeDialog')
            } else {
              _g.toast("error", '修改失败!');
            }
          }, (err) => {
            this.loading = false
          })
        })
      }

    },
    resetForm() {
      this.$emit('closeDialog')
    },
    // 编辑时删除
    editRemoveDomain(item, listIndex) {
      var index = this.formData.productList.indexOf(item)
      if (index !== -1) {
        this.formData.productList.splice(listIndex, 1)
      }
      this.$forceUpdate()
    },
    // 编辑时新增
    editDomain() {
      this.formData.productList.push({
        menuSpec: "",
        price: '',
        key: Date.now()
      });
      this.$forceUpdate()
    },
  }
}
</script>
<style scoped>
.footer {
  display: flex;
  justify-content: space-around;
  margin-top: 60px;
}
.sure {
  margin-left: 50px;
}
.title {
  text-align: center;
  margin-bottom: 30px;
}
.addProject >>> .el-form-item__content {
  line-height: 40px !important;
}
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
.footer >>> .el-form-item__content {
  margin-left: 0 !important;
}
</style>